import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const GridIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill={props.fill ?? 'none'}
    {...props}
  >
    <Path
      d='M10 3H3v7h7V3ZM21 3h-7v7h7V3ZM21 14h-7v7h7v-7ZM10 14H3v7h7v-7Z'
      stroke={props.color ?? '#3379BD'}
      fill={props.fill ?? 'transparent'}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
);

export default GridIcon;
